export interface MarketPrice {
  id: string;
  market: string;
  province: string;
  variety: string;
  price: number;
  unit: string;
  change: number;
  updateDate: string;
}

export const marketPrices: MarketPrice[] = [
  { id: 'mp-1', market: '寿光农产品物流园', province: '山东', variety: '普通黄瓜', price: 2.4, unit: '元/公斤', change: -0.3, updateDate: '2026-08-07' },
  { id: 'mp-2', market: '北京新发地市场', province: '北京', variety: '普通黄瓜', price: 3.2, unit: '元/公斤', change: 0.1, updateDate: '2026-08-07' },
  { id: 'mp-3', market: '广州江南市场', province: '广东', variety: '普通黄瓜', price: 3.8, unit: '元/公斤', change: 0.2, updateDate: '2026-08-07' },
  { id: 'mp-4', market: '郑州万邦国际', province: '河南', variety: '普通黄瓜', price: 2.6, unit: '元/公斤', change: -0.1, updateDate: '2026-08-07' },
  { id: 'mp-5', market: '武汉白沙洲市场', province: '湖北', variety: '普通黄瓜', price: 3.0, unit: '元/公斤', change: 0.0, updateDate: '2026-08-07' },
  { id: 'mp-6', market: '南京众彩市场', province: '江苏', variety: '普通黄瓜', price: 2.9, unit: '元/公斤', change: -0.2, updateDate: '2026-08-07' },
  { id: 'mp-7', market: '寿光农产品物流园', province: '山东', variety: '水果黄瓜', price: 6.5, unit: '元/公斤', change: 0.3, updateDate: '2026-08-07' },
  { id: 'mp-8', market: '北京新发地市场', province: '北京', variety: '水果黄瓜', price: 7.8, unit: '元/公斤', change: 0.0, updateDate: '2026-08-07' },
  { id: 'mp-9', market: '广州江南市场', province: '广东', variety: '水果黄瓜', price: 8.5, unit: '元/公斤', change: 0.5, updateDate: '2026-08-07' },
  { id: 'mp-10', market: '上海江桥市场', province: '上海', variety: '普通黄瓜', price: 3.5, unit: '元/公斤', change: 0.0, updateDate: '2026-08-07' },
];